import styled from 'styled-components';

const Bold = styled.span`
  font-weight: bold;
  margin: 0px 10px;
  min-width: fit-content;
`;

export default Bold;
